import { render, staticRenderFns } from "./ModalAddGuests.vue?vue&type=template&id=c962ff36&"
import script from "./ModalAddGuests.vue?vue&type=script&lang=js&"
export * from "./ModalAddGuests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports